import type { UserAttributes } from '@/server/models'

import CourseQ from '@/queries/CourseQ'
import SessionHostQ from '@/queries/SessionHostQ'
import SessionQ from '@/queries/SessionQ'
import TopicQ from '@/queries/TopicQ'
import UserQ from '@/queries/UserQ'
import { SQL, type SQLFragment } from '@/client/query'
import composer from '@/client/query/composer'

import { CATEGORY_TO_SEARCH_FILTER } from './constants'

const ACTIVE_TUTOR_LOOKBACK_DAYS = 90

export default function getTutorsSearchQuery({
  courseSlugs,
  userId,
  searchParam,
}: {
  courseSlugs: string[]
  userId: number
  searchParam: string
}): SQLFragment<UserAttributes> {
  const tutorsQuery = composer(({ ref, alias }) => ({
    from: [
      {
        alias: alias('courses'),
        id: CourseQ.id,
        where: CourseQ.where({
          slug: courseSlugs.length > 0 ? SQL`ANY(${courseSlugs})` : null,
        }),
        materialized: false,
      },
      {
        alias: alias('topics'),
        id: TopicQ.id,
        where: TopicQ.where({
          courseId: ref('courses'),
        }),
        materialized: false,
      },
      {
        alias: alias('sessions'),
        id: SessionQ.id,
        where: SessionQ.where(
          {
            topicId: ref('topics'),
          },
          SQL`${SessionQ.end_date} > NOW() - ${ACTIVE_TUTOR_LOOKBACK_DAYS} * INTERVAL '1 day'`
        ),
        materialized: false,
      },
      {
        alias: alias('session_hosts'),
        id: SessionHostQ.user_id,
        where: SessionHostQ.where({
          sessionId: ref('sessions'),
        }),
        materialized: false,
      },
    ],
    gather: {
      id: UserQ.id,
      where: UserQ.where(
        {
          id: ref('session_hosts'),
        },
        UserQ.isBucketCompatible({ myUserId: userId, targetUserId: UserQ.id })
      ),
    },
  }))

  return SQL`
          ${UserQ.where({}, SQL`${UserQ.id} IN (${tutorsQuery})`)}
          AND ${UserQ.hasTutorRole()}
          AND ${CATEGORY_TO_SEARCH_FILTER.Tutors(searchParam)}
      `
}
